module.exports = __webpack_public_path__ + "img/iso.92d48fae.svg";